const commonActions = {
  setUser: (context, res) => {
    context.commit("getUser", res);
  },
  setAddress: (context, res) => {
    context.commit("getAddress", res);
  }

  // setMenu: (context, res) => {
  //   context.commit('getMenu', res)
  // },
};
export default commonActions;
